import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { rootReducer } from "./reducers";
import { rootSaga } from "./sagas";
import { registerStore } from "./storeRegistry";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: ["payload.onSuccess", "payload.onError"],
      },
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

registerStore(store);

// Types are now exported from types.ts
